import React from 'react';
import {
    FileText,
    Search,
    Plus,
    Grid,
    List,
    Star,
    Clock,
    Tag as TagIcon,
    Sparkles,
    ArrowRight
} from 'lucide-react';
import './ContentLibrary.css';

const libStats = [
    { label: 'Total Snippets', value: '1,248', icon: <FileText size={20} />, color: '#FF5526' },
    { label: 'Avg. Time Saved', value: '15m/use', icon: <Clock size={20} />, color: '#10B981' },
    { label: 'Reuse Rate', value: '68%', icon: <Sparkles size={20} />, color: '#F59E0B' },
    { label: 'Verified Content', value: '94%', icon: <TagIcon size={20} />, color: '#FF5526' },
];

const aiSuggestions = [
    { id: 1, title: 'SOC 2 Type II Compliance', category: 'Security', description: 'Updated response for 2024 auditing standards...' },
    { id: 2, title: 'Disaster Recovery Plan', category: 'Technical', description: 'Comprehensive failover and backup procedure...' },
    { id: 3, title: 'Multi-tenant Isolation', category: 'Infrastructure', description: 'Explanation of logical separation at DB level...' },
];

const categories = ['All', 'Technical', 'Commercial', 'Compliance', 'Security', 'Legal'];

const snippets = [
    { id: 1, title: 'Data Encryption at Rest', category: 'Security', rating: 4.9, used: 124 },
    { id: 2, title: 'SLA Support Tiers', category: 'Commercial', rating: 4.7, used: 85 },
    { id: 3, title: 'API Authentication Flow', category: 'Technical', rating: 4.8, used: 212 },
    { id: 4, title: 'General Liability Insurance', category: 'Legal', rating: 4.5, used: 56 },
    { id: 5, title: 'Auto-scaling Logic', category: 'Infrastructure', rating: 4.9, used: 143 },
    { id: 6, title: 'GDPR Compliance Statement', category: 'Compliance', rating: 4.6, used: 310 },
];

const ContentLibrary = () => {
    return (
        <div className="library-page">
            <header className="page-header">
                <div>
                    <h1>Content Library</h1>
                    <p className="subtitle">Search and reuse high-performing responses from past proposals.</p>
                </div>
                <button className="primary-btn"><Plus size={18} /> Add Content</button>
            </header>

            <section className="stats-grid">
                {libStats.map((stat, index) => (
                    <div key={index} className="stat-card">
                        <div className="stat-icon" style={{ backgroundColor: `${stat.color}15`, color: stat.color }}>
                            {stat.icon}
                        </div>
                        <div className="stat-info">
                            <span className="stat-label">{stat.label}</span>
                            <span className="stat-value">{stat.value}</span>
                        </div>
                    </div>
                ))}
            </section>

            <section className="ai-row">
                <div className="section-header">
                    <div className="flex-center gap-1">
                        <Sparkles size={18} className="text-indigo" />
                        <h2 className="section-title">AI Content Suggestions</h2>
                    </div>
                </div>
                <div className="ai-card-grid">
                    {aiSuggestions.map(item => (
                        <div key={item.id} className="ai-suggestion-card compact">
                            <div className="ai-card-header">
                                <span className="tag-pill">{item.category}</span>
                                <button className="icon-btn-small"><Plus size={14} /></button>
                            </div>
                            <h3>{item.title}</h3>
                            <p>{item.description}</p>
                            <button className="text-link">Reuse Snippet <ArrowRight size={14} /></button>
                        </div>
                    ))}
                </div>
            </section>

            <div className="filter-bar">
                <div className="search-box">
                    <Search size={18} />
                    <input type="text" placeholder="Search snippets, tags, categories..." />
                </div>
                <div className="filter-actions">
                    <div className="category-pills">
                        {categories.map((cat, i) => (
                            <button key={cat} className={`pill-btn ${i === 0 ? 'active' : ''}`}>{cat}</button>
                        ))}
                    </div>
                    <div className="view-toggles">
                        <button className="icon-btn-border active"><Grid size={18} /></button>
                        <button className="icon-btn-border"><List size={18} /></button>
                    </div>
                </div>
            </div>

            <div className="snippet-grid">
                {snippets.map(snippet => (
                    <div key={snippet.id} className="snippet-card">
                        <div className="snippet-icon">
                            <FileText size={20} />
                        </div>
                        <div className="snippet-main">
                            <h3>{snippet.title}</h3>
                            <div className="snippet-meta">
                                <span className="snip-tag">{snippet.category}</span>
                                <div className="snip-rating">
                                    <Star size={14} className="star-filled" />
                                    <span>{snippet.rating}</span>
                                </div>
                            </div>
                        </div>
                        <div className="snippet-stats">
                            <span>{snippet.used} uses</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ContentLibrary;
